import { useLocation, useParams } from "react-router-dom";

// ID системы дашборда "Мои Задачи" (см. systemRoutes["3"] в src/routes/routes.tsx)
const MY_TASKS_SYSTEM_ID = "3";

// reportID страницы "Отчет по действиям" (см. myTaskReportRoutes[1] в MyTaskReportCard.tsx)
const ACTIONS_REPORT_ID = "1";

/**
 * Определяет, находится ли пользователь на одной из страниц, где логика скрытия
 * локации "Регион" (см. filterHiddenMyTasksLocationData в
 * src/modules/spItems/api/getStrapiItemsRequest.ts) не должна применяться:
 * "Совещания" (/dashboard/3/meetings) и "Отчет по действиям" (/dashboard/3/reports/1).
 */
export function useIsRegionHiddenExemptPage(): boolean {
  const { id } = useParams();
  const location = useLocation();

  if (id !== MY_TASKS_SYSTEM_ID) return false;

  const isMeetingsPage = /\/meetings(\/|$)/.test(location.pathname);
  const isActionsReportPage = new RegExp(`/reports/${ACTIONS_REPORT_ID}(/|$)`).test(location.pathname);

  return isMeetingsPage || isActionsReportPage;
}
